// ─────────────────────────────────────────────
//  sandbox/exit — the way OUT of demo mode.
//
//  THE TRAP THIS CLOSES: `enterSandbox()` had a caller (GetStartedPage, "Test
//  Solo") and `leaveSandbox()` had NONE. One tap swapped the app onto a local
//  store for good: signing out did not clear the flag, so signing back in with
//  a real hospital account still booted into the demo database. The app looked
//  normal — logged in, facility "sbx" — while it registered no push token
//  (native/push.js), showed no messages, and could never reach the hospital's
//  board. On a phone the only escape was clearing app data or reinstalling.
//
//  ⚠️ LEAVING MUST BE A FULL DOCUMENT LOAD, exactly like entering.
//  `firebase/config.js` binds `db` once at boot; a client-side navigation would
//  clear the flag while the app keeps writing to the LOCAL store, and the user
//  would believe they were back on their hospital's data. That is worse than
//  being stuck, because it is invisible. Same `window.location.assign` idiom
//  GetStartedPage uses, injectable so tests observe it without navigating jsdom.
// ─────────────────────────────────────────────
import { isSandboxBoot, leaveSandbox } from "./mode";

export const hardReload = (path) => { window.location.assign(path); };

// Clear the flag and reboot the app onto real Firestore.
export function exitSandbox(path = "/login", reload = hardReload) {
  leaveSandbox();
  reload(path);
}

// Sign-out is the natural boundary: the demo session is over, so the next boot
// should be the real app. Returns true when it handled the exit, so a caller
// can keep its normal post-sign-out behaviour otherwise.
export function exitSandboxOnSignOut(path = "/login", reload = hardReload) {
  if (!isSandboxBoot()) return false;
  exitSandbox(path, reload);
  return true;
}
